import React from "react";

export default ({ text, classes, isRed = false, isWhite = false, isSpan }) => {
    if (!text) return null;
        if(isSpan) {
            return <span
                className={ "a-label" +
                (isRed ? " a-label--red" : "") +
                (isWhite ? " a-label--white" : "") +
                (classes ? (" " + classes) : "") }
            >
                { text }
            </span>;
        } else {
            return <p
                className={ "a-label" +
                (isRed ? " a-label--red" : "") +
                (isWhite ? " a-label--white" : "") +
                (classes ? (" " + classes) : "") }
            >
                { text }
            </p>;
        }

}